import React, { useEffect, useState } from 'react'
import * as routeLink from "../../constants/routeLink";
import { useNavigate } from 'react-router-dom';
import { createChart } from 'lightweight-charts';
import { useSelector } from 'react-redux';
import { bet, domain, getChartData, history, } from '../../services/services';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
let chart
let area

const Index = (props) => {
  const [timeChart, setTimeChart] = useState('1m');

  return (
    <div>
    <div className="__className_0e7922">
        <div style={{opacity: 1, transition: "opacity 0.3s"}} className="bg-[rgb(97,231,59)]">
            <div className="relative mx-auto main-axis-content">
                <div className="relative w-full" style={{paddingTop:"calc(100% / 0.4413793103)"}}><img
                        alt="competition detail" loading="lazy" decoding="async" data-nimg="fill"
                        className="object-cover"
                        style={{position:"absolute",height:"100%",width:"100%",left:0,top:0,right:0,bottom:0,color:"transparent"}}
                        sizes="100vw"
                        
                        src={`${routeLink.domain}/assets/imgs/competition-bg.png`}/><a
                        className="w-[150px] h-[41px] left-[calc(50%_-_75px)] md:w-[200px] md:h-[55px] md:left-[calc(50%_-_100px)] lg:w-[312px] lg:h-[86px] lg:left-[calc(50%_-_156px)] top-[16%] hover:brightness-110 absolute transform transition-all duration-300 cursor-pointer ease-in-out hover:scale-105"
                        target="_blank"
                        href="https://dorahacks.io/hackathon/fourmeme-oscars/detail">
                        <div
                            className="z-[1] absolute flex-h-cc pr-4 w-full h-[30px] md:h-[40px] lg:h-[60px] t-700-16-white lg:t-700-24-white">
                            Apply Now</div><img alt="Apply now button" loading="lazy"
                            decoding="async" data-nimg="fill"
                            style={{position:"absolute",height:"100%",width:"100%",left:0,top:0,right:0,bottom:0,color:"transparent"}}
                            sizes="328px"
                            
                            src={`${routeLink.domain}/assets/imgs/competition-btn.png`}/>
                    </a></div>
            </div>
        </div>
        <div className="bg-white -mb-24 pt-[88px] pb-[130px]"
            style={{backgroundImage:"url('static/imgs/person-question.47023f24.png')",backgroundRepeat:"repeat",backgroundSize:"360px 340px"}}>
            <div className="flex-v-cc mx-auto px-4 xl:px-0 main-axis-content">
                <h2 className="relative mb-8 t-700-40-black">
                    <div className="relative z-[1]">FREQUENTLY ASKED QUESTIONS (FAQS)</div>
                    <div className="bottom-3 left-0 z-0 absolute bg-primary w-full h-4"></div>
                </h2>
                <ul className="flex-v gap-2.5 w-full">
                    <li className="cursor-pointer bg-primary px-5 pt-3 rounded-2xl overflow-hidden transition-all duration-500 ease-out pb-4"
                        style={{maxHeight: "1000px"}}>
                        <div className="flex items-start">
                            <div className="mr-5 t-800-24-white">01</div>
                            <div className="flex-1">
                                <h3 className="t-600-20-black">Who is eligible to apply for the
                                    competition?</h3>
                                <div className="overflow-hidden transition-all duration-300 ease-out"
                                    style={{maxHeight: "1000px", opacity: 1,visibility: "visible"}}>
                                    <div className="mt-2 leading-[19px] t-500-16-black">Any individual
                                        or project is welcome to apply.Token projects must be
                                        enrolled on the campaign landing page and create their token
                                        on four.meme platform, otherwise they will not be considered
                                        as part of the&nbsp; selection for the competition.</div>
                                </div>
                            </div><button type="button"
                                className="t-500-black leading-5 pt-1 w-4 text-[48px]">-</button>
                        </div>
                    </li>
                    <li className="cursor-pointer bg-primary px-5 pt-3 rounded-2xl overflow-hidden transition-all duration-500 ease-out pb-4"
                        style={{maxHeight: "1000px"}}>
                        <div className="flex items-start">
                            <div className="mr-5 t-800-24-white">02</div>
                            <div className="flex-1">
                                <h3 className="t-600-20-black">How to register? What information needs
                                    to be submitted?</h3>
                                <div className="overflow-hidden transition-all duration-300 ease-out"
                                    style={{maxHeight: "1000px", opacity: 1,visibility: "visible"}}>
                                    <div className="mt-2 leading-[19px] t-500-16-black">You can go to
                                        the registration page through "Apply Now" on the event page
                                        to register. Registration information includes: token name,
                                        token ticker, token logo, token story background (the more
                                        detailed the better, if you have relevant documents you can
                                        upload them), website, Twitter, TG, team contact information
                                        (required, otherwise considered as an invalid entry)</div>
                                </div>
                            </div><button type="button"
                                className="t-500-black leading-5 pt-1 w-4 text-[48px]">-</button>
                        </div>
                    </li>
                    <li className="cursor-pointer bg-primary px-5 pt-3 rounded-2xl overflow-hidden transition-all duration-500 ease-out pb-4"
                        style={{maxHeight: "1000px"}}>
                        <div className="flex items-start">
                            <div className="mr-5 t-800-24-white">03</div>
                            <div className="flex-1">
                                <h3 className="t-600-20-black">What are the selection criteria for each
                                    award? How many nominees are there?</h3>
                                <div className="overflow-hidden transition-all duration-300 ease-out"
                                    style={{maxHeight: "1000px", opacity: 1,visibility: "visible"}}>
                                    <div className="mt-2 leading-[19px] t-500-16-black">
                                        <div className="relative">
                                            <div>The criteria used is as follows:</div>
                                            <div
                                                className="border-2 my-3 border-black/70 rounded-2xl overflow-hidden">
                                                <table
                                                    className="border-0 -m-[1px] w-[calc(100%_+_2px)]">
                                                    <thead>
                                                        <tr>
                                                            <th
                                                                className="px-2 py-1 border border-black undefined">
                                                                Award Title</th>
                                                            <th
                                                                className="px-2 py-1 border border-black undefined">
                                                                Selection Criteria</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                Best Meme</td>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                Market cap 50% + Dex vol 50%, top 5
                                                                will be winner candidate</td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                Best Trade</td>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                Gas used 40% + Dex vol 60%, top 5
                                                                will be winner candidate</td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                Best Community</td>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                TweetScout Score 50% + Total
                                                                Community Users 50%</td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                Best Original Narrative</td>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                When registering for a project,
                                                                users need to describe the story
                                                                background of their project or
                                                                submit relevant documents. Users can
                                                                vote on it during the event. A
                                                                voting link will be prepared. The
                                                                five projects with the highest votes
                                                                are shortlisted.</td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                Best Investment</td>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                by the selection deadline, the five
                                                                projects with the highest currency
                                                                ROI will be shortlisted</td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                Best Holder</td>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                By the selection deadline, the five
                                                                projects with the most Holders will
                                                                be shortlisted. The effective holder
                                                                is that the currency holding value
                                                                is greater than or equal to 5u</td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                Best Potential</td>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                Market cap 50% + Dex vol 50% (Top
                                                                6-10 meme projects list)</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div>
                                                <div><b>Specifics of best community*:</b> The
                                                    community score for a candidate will be
                                                    calculated based on two factors, each
                                                    contributing 50% to the final score:</div>
                                                <div><b>1. TweetScout Score (50%):</b> The score
                                                    that a candidate receives on TweetScout will
                                                    account for 50% of their total community score.
                                                </div>
                                                <div className="mb-8"><b>2. Total Community Users
                                                        (50%):</b> The total number of community
                                                    users is determined by summing up the users from
                                                    the project’s Discord and Telegram communities.
                                                    If a project only has one of these platforms,
                                                    the user count from that platform will be used.
                                                    The project with the highest total number of
                                                    users will receive 100 points. Other projects’
                                                    community scores will be calculated
                                                    proportionally by comparing their user base to
                                                    that of the leading project.</div>
                                                <div className="mb-8">For example, if Project A has the
                                                    largest user base with 100,000 users, it will
                                                    receive 100 points. If Project B has 85,000
                                                    users, its score will be calculated as
                                                    85,000/100,000, resulting in 85 points in this
                                                    portion of the scoring system.</div>
                                                <div><b>Nominee Score(Total 100 points):</b> The top
                                                    five token projects for each award nominee will
                                                    get 100/90/80/70/60 points in turn.</div>
                                                <div>Moreover，Registered token projects must meet
                                                    market capitalization requirements and launch on
                                                    pancakeswap during the campaign period to be
                                                    eligible as nominees. Each award category has 5
                                                    nominees.</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div><button type="button"
                                className="t-500-black leading-5 pt-1 w-4 text-[48px]">-</button>
                        </div>
                    </li>
                    <li className="cursor-pointer bg-primary px-5 pt-3 rounded-2xl overflow-hidden transition-all duration-500 ease-out pb-4"
                        style={{maxHeight: "1000px"}}>
                        <div className="flex items-start">
                            <div className="mr-5 t-800-24-white">04</div>
                            <div className="flex-1">
                                <h3 className="t-600-20-black">What is the final criteria of selection
                                    for the winning meme?</h3>
                                <div className="overflow-hidden transition-all duration-300 ease-out"
                                    style={{maxHeight: "1000px", opacity: 1,visibility: "visible"}}>
                                    <div className="mt-2 leading-[19px] t-500-16-black">
                                        <div>
                                            <div className="mb-6">The five nominees for each award are
                                                subject to a public vote as well as a selection
                                                committee vote. The public vote and the committee
                                                vote are each weighted 50%.</div>
                                            <div className="mb-6"><b>Public vote score(Total 100
                                                    points):</b> The score distribution is based on
                                                the number of votes received. The five token
                                                projects will get 100/90/80/70/60 scores in turn
                                                from highest to lowest.</div>
                                            <div className="mb-6"><b>Committee score(Total 100
                                                    points):</b> Each judge votes for the project
                                                they think is the best for each award. There are a
                                                total of 5 judges voting. The score for each project
                                                is calculated based on the proportion of votes
                                                received. For example, project A gets 3 votes from 5
                                                judges, then the committee score is (3/5) * 100 = 60
                                                points</div>
                                            <div className="mb-6">Then, Final winner score = nominee
                                                score + public vote score * 50% + committee score *
                                                50%. The final winner of each award is the one with
                                                the highest score.</div>
                                            <div><b>For example:</b></div>
                                            <div
                                                className="border-2 my-3 border-black/70 rounded-2xl overflow-hidden">
                                                <table className="border-0 -m-[1px] w-full">
                                                    <thead>
                                                        <tr>
                                                            <th
                                                                className="px-2 py-1 border border-black undefined">
                                                                Project</th>
                                                            <th
                                                                className="px-2 py-1 border border-black undefined">
                                                                Nominee score</th>
                                                            <th
                                                                className="px-2 py-1 border border-black undefined">
                                                                Public vote score</th>
                                                            <th
                                                                className="px-2 py-1 border border-black undefined">
                                                                Committee score</th>
                                                            <th
                                                                className="px-2 py-1 border border-black undefined">
                                                                Final winner score</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                A</td>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                100</td>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                100</td>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                (⅕)*100=20</td>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                100+100*50%+20*50%=160</td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                B</td>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                90</td>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                60</td>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                (⅖)*100=40</td>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                90+60*50%+40*50%=140</td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                C</td>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                80</td>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                90</td>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                (0/5)*100=0</td>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                80+90*50%+0=125</td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                D</td>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                70</td>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                70</td>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                (⅕)*100=20</td>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                70+70*50%+20*50%=115</td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                E</td>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                60</td>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                80</td>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                (⅕)*100=20</td>
                                                            <td
                                                                className="px-2 py-1 border border-black undefined">
                                                                60+80*50%+20*50%=110</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div>So project A wins the final award with the highest
                                                score.</div>
                                        </div>
                                    </div>
                                </div>
                            </div><button type="button"
                                className="t-500-black leading-5 pt-1 w-4 text-[48px]">-</button>
                        </div>
                    </li>
                    <li className="cursor-pointer bg-primary px-5 pt-3 rounded-2xl overflow-hidden transition-all duration-500 ease-out pb-4"
                        style={{maxHeight: "1000px"}}>
                        <div className="flex items-start">
                            <div className="mr-5 t-800-24-white">05</div>
                            <div className="flex-1">
                                <h3 className="t-600-20-black">Who is part of the selection committee?
                                </h3>
                                <div className="overflow-hidden transition-all duration-300 ease-out"
                                    style={{maxHeight: "1000px", opacity: 1,visibility: "visible"}}>
                                    <div className="mt-2 leading-[19px] t-500-16-black">
                                        <div>
                                            <div>The selection committee consists of five members:
                                            </div>
                                            <ul className="pl-4 list-disc list-item">
                                                <li>Campaign organizer: Four.meme</li>
                                                <li>Campaign official partner: $Why</li>
                                                <li>Campaign official partner: $Four</li>
                                                <li>Famous crypto KOL: BILI</li>
                                                <li>Special guest: Notable NBA star: Tristan
                                                    Thompson</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div><button type="button"
                                className="t-500-black leading-5 pt-1 w-4 text-[48px]">-</button>
                        </div>
                    </li>
                    <li className="cursor-pointer bg-primary px-5 pt-3 rounded-2xl overflow-hidden transition-all duration-500 ease-out pb-4"
                        style={{maxHeight: "1000px"}}>
                        <div className="flex items-start">
                            <div className="mr-5 t-800-24-white">06</div>
                            <div className="flex-1">
                                <h3 className="t-600-20-black">When will the prizes be distributed?</h3>
                                <div className="overflow-hidden transition-all duration-300 ease-out"
                                    style={{maxHeight: "1000px", opacity: 1,visibility: "visible"}}>
                                    <div className="mt-2 leading-[19px] t-500-16-black">The winning
                                        address of the campaign will be announced publicly. All
                                        points and token prizes involved will be distributed to the
                                        winners' corresponding bsc wallet addresses within two weeks
                                        after the campaign ends.</div>
                                </div>
                            </div><button type="button"
                                className="t-500-black leading-5 pt-1 w-4 text-[48px]">-</button>
                        </div>
                    </li>
                    <li className="cursor-pointer bg-primary px-5 pt-3 rounded-2xl overflow-hidden transition-all duration-500 ease-out pb-4"
                        style={{maxHeight: "1000px"}}>
                        <div className="flex items-start">
                            <div className="mr-5 t-800-24-white">07</div>
                            <div className="flex-1">
                                <h3 className="t-600-20-black">Terms and Conditions</h3>
                                <div className="overflow-hidden transition-all duration-300 ease-out"
                                    style={{maxHeight: "1000px", opacity: 1,visibility: "visible"}}>
                                    <div className="mt-2 leading-[19px] t-500-16-black">Four.meme
                                        reserves the right to cancel or amend any Activity or
                                        Activity Rules at our sole discretion. Four.meme reserves
                                        the right of final interpretation.</div>
                                </div>
                            </div><button type="button"
                                className="t-500-black leading-5 pt-1 w-4 text-[48px]">-</button>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
  )
}

export default Index;
